import API from "@/api/serverCall";
import {
	PaymentCurrentResponseType,
	PaymentPlanResponseType,
	PostContactUsRequestType,
} from "@/views/Price/types";
import { CompanySubscribeVerifyResponseDto, ContactUsRequestDto } from "@/api/interface";

export function getPaymentCurrent(): Promise<PaymentCurrentResponseType> {
	return new Promise((resolve, reject) => {
		API.get<PaymentCurrentResponseType>({
			link: "/payment/current",
		})
			.then((res) => {
				resolve(res.data);
			})
			.catch((e) => {
				reject(e);
			});
	});
}

export function getPaymentPlan(): Promise<PaymentPlanResponseType[]> {
	return new Promise((resolve, reject) => {
		API.get<PaymentPlanResponseType[]>({
			link: "/payment/plan",
		})
			.then((res) => {
				resolve(res.data);
			})
			.catch((e) => {
				reject(e);
			});
	});
}

export function getSubscribeUniqueKey(planId: number): Promise<string> {
	return new Promise((resolve, reject) => {
		API.get<string>({
			link: `/company/subscribe/${planId}`,
		})
			.then((res) => {
				resolve(res.data);
			})
			.catch((e) => {
				reject(e);
			});
	});
}

export function postCompanySubscribe(
	payload: CompanySubscribeVerifyResponseDto,
): Promise<string> {
	return new Promise((resolve, reject) => {
		API.post<string>({
			link: "/company/subscribe",
			body: payload,
		})
			.then((res) => {
				resolve(res.data);
			})
			.catch((e) => {
				reject(e);
			});
	});
}

export function postContactUs({
	type,
	contents,
	email,
	title,
	manager,
}: PostContactUsRequestType): Promise<string> {
	const body: ContactUsRequestDto = {
		title,
		email,
		contents,
		manager,
	};

	let link = "";
	switch (type) {
		case "premium":
			link = "/contactus/premium";
			break;
		case "makeApp":
			link = "/contactus/makeApp";
			break;
		default:
			link = "/contactus/normal";
			break;
	}

	return new Promise((resolve, reject) => {
		API.post<string>({
			link,
			body,
		})
			.then((res) => {
				resolve(res.data);
			})
			.catch((e) => {
				reject(e);
			});
	});
}
